import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const EmailLine16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 1.875C1.3264 1.875 0.375 2.82639 0.375 4V12C0.375 13.1736 1.3264 14.125 2.5 14.125H13.5C14.6736 14.125 15.625 13.1736 15.625 12V4C15.625 2.82639 14.6736 1.875 13.5 1.875H2.5ZM1.625 4C1.625 3.51675 2.01675 3.125 2.5 3.125H13.5C13.9832 3.125 14.375 3.51675 14.375 4V4.30124L9.2843 7.57383C8.50196 8.07676 7.49804 8.07676 6.7157 7.57383L1.625 4.30124V4ZM1.625 5.78725V12C1.625 12.4832 2.01675 12.875 2.5 12.875H13.5C13.9832 12.875 14.375 12.4832 14.375 12V5.78725L9.96025 8.6253C8.76614 9.39294 7.23386 9.39294 6.03975 8.6253L1.625 5.78725Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
